export default "__VITE_ASSET__DUT2yXOr__"